<template>
  <el-dialog
    :title="$t('buildingBrowseManage.view.title')"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="120px" :disabled="true">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingBrowseManage.form.buildingName')">
            <el-input v-model="form.buildingName" :placeholder="$t('buildingBrowseManage.form.buildingNamePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingBrowseManage.form.userName')">
            <el-input v-model="form.userName" :placeholder="$t('buildingBrowseManage.form.userNamePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingBrowseManage.form.userTel')">
            <el-input v-model="form.userTel" :placeholder="$t('buildingBrowseManage.form.userTelPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingBrowseManage.form.createTime')">
            <el-input v-model="form.createTime" :placeholder="$t('buildingBrowseManage.form.createTimePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingBrowseManage.form.statusCd')">
            <el-select v-model="form.statusCd" :placeholder="$t('buildingBrowseManage.form.statusCdPlaceholder')" style="width: 100%;">
              <el-option :label="$t('buildingBrowseManage.statusCdOptions.normal')" value="0" />
              <el-option :label="$t('buildingBrowseManage.statusCdOptions.disabled')" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewBuildingBrowseView',
  data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        buildingId: '',
        buildingName: '',
        userId: '',
        userName: '',
        userTel: '',
        createTime: '',
        statusCd: '0'
      }
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      if (data) {
        this.form = { ...data }
      } else {
        this.resetForm()
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.form = {
        id: '',
        buildingId: '',
        buildingName: '',
        userId: '',
        userName: '',
        userTel: '',
        createTime: '',
        statusCd: '0'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>